import { ModelId } from "../../../../defines";
import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import InvestorInvestmentEndpoints from "../../../endpoints/Investment/investor";
import ManagerInvestmentEndpoints from "../../../endpoints/Investment/manager";
import { InvestmentsStatusType } from "../../../enums";
import { InvestmentModel } from "../../../models";
import { ModelScope } from "../../../types";

export function apiInvestmentModel(opts: ApiModelOptions<InvestmentModel>) {
  const model = ApiModel<InvestmentModel>("investment", {
    urls: {
      [ModelScope.Investor]: InvestorInvestmentEndpoints,
      [ModelScope.Manager]: ManagerInvestmentEndpoints,
      [ModelScope.Mallcop]: {
        getOne: "/investments/:id",
        getMany: "/investments",
        create: "/investments",
        update: "/investments/:id",
        delete: "/investments/:id",
      },
    },
    ...opts,
  });

  const getPending = async (managerId?: string, investorId?: string) => {
    return await model.getMany(undefined, {
      type: "NoOversubscribed",
      "page[size]": 1000,
      user_id: investorId,
      status: `!${InvestmentsStatusType.Completed}`,
      ...(managerId && { manager_id: managerId }),
    });
  };

  const sendPledgeNotification = async (idInvestment: string | number) => {
    return await opts.placementsApiClient.rpcRequest(
      "send-investment-notifications",
      {
        id: String(idInvestment),
      },
    );
  };

  const sendSubscriptionDocuments = async (idInvestment: string) => {
    return await model.handler.apiRequest(
      `/investments/${idInvestment}/send/document`,
      "POST",
    );
  };

  const voidDocusign = async (idInvestment: string, message?: string) => {
    const body = message ? { message } : {};
    return await model.handler.post(
      `/investments/${idInvestment}/void/document`,
      body,
      false,
    );
  };

  const calculateByInvestment = async (idInvestment: ModelId) => {
    return await model.handler.rpcRequest("calculate-by-investment", {
      id: Number(idInvestment),
    });
  };

  const uncheckDocumentsUploadedStep = async (idInvestment: ModelId) => {
    return await model.update(
      String(idInvestment),
      {
        documentsUploadedAt: null,
        status: InvestmentsStatusType.InProcess,
      },
      undefined,
      false,
    );
  };

  return {
    ...model,
    uncheckDocumentsUploadedStep,
    sendPledgeNotification,
    sendSubscriptionDocuments,
    calculateByInvestment,
    getPending,
    voidDocusign,
  };
}

export default apiInvestmentModel;
